import { FieldConfig, FieldRules, FieldRulesConfig } from '@/types/form'

export interface OrderSourceFormState {
  name: string
  status: 'active' | 'inactive'
}

export const orderSourceFields: (keyof OrderSourceFormState)[] = ['name', 'status']

interface OrderSourceFieldsConfig extends FieldConfig<{
  name: FieldRules<OrderSourceFormState['name']>
  status: FieldRules<OrderSourceFormState['status']>
}> {}

interface OrderSourceFieldsConfigProps extends FieldRulesConfig<OrderSourceFormState> {}

export function orderSourceFieldsConfig(
  _props: OrderSourceFieldsConfigProps
): OrderSourceFieldsConfig {
  return {
    fields: {
      name: {
        rules: {
          required: 'Source name is required',
        },
      },
      status: {
        rules: {
          required: 'Status is required',
        },
      },
    },
  }
}
